import i18n from 'i18next';
import { FieldError } from './ValidationError';

/** Format field/input errors that come from BE so they can be easily used with Formik's setErrors function */
const formatBackendValidationErrors = (
  fieldErrors: FieldError[] = [],
  propertyFormik?: string, // formik property in case BE doesn't send the property name
) => {
  const errors: { [index: string]: string } = {};
  fieldErrors.forEach((fieldError) => {
    let { property } = fieldError;
    if (property?.includes('.')) {
      const split = property.split('.');
      property = split[split.length - 1]; // Get the field name of nested object
    }
    let errorMessage = fieldError.messageTemplate;
    if (!errorMessage) {
      if (fieldError.message?.includes('java.lang.Integer')) {
        errorMessage = 'integer_number'; // TODO: Remove this when BE manage this error.
      } else errorMessage = 'invalid_format';
    }
    errors[propertyFormik || property] = i18n.t(
      `error:validation.${errorMessage}`,
    );
  });
  return errors;
};

export default formatBackendValidationErrors;
